import {
  GOL_MISSION,
  ARGOS_MISSION,
  TU_MISSION,
  BANK_MISSION,
  AFS_MISSION,
  HABITAT_MISSION,
  SAVINGCARD_MISSION,
} from "constants/registrationForm";

import golImg from "images/gol.png";
import argosImg from "images/argos.png";
import tuImg from "images/tu.png";
import bankImg from "images/sainsburys_bank.png";
import argosFin from "images/argos_fin.png";
import habitatImg from "images/habitat.png";
import savingcardImg from "images/savingcard.svg";

const prefSelectOptions = [
  {
    name: GOL_MISSION,
    imgUrl: golImg,
  },
  {
    name: ARGOS_MISSION,
    imgUrl: argosImg,
  },
  {
    name: TU_MISSION,
    imgUrl: tuImg,
  },
  {
    name: BANK_MISSION,
    imgUrl: bankImg,
  },
  {
    name: AFS_MISSION,
    imgUrl: argosFin,
  },
  {
    name: HABITAT_MISSION,
    imgUrl: habitatImg,
  },
   {
      name: SAVINGCARD_MISSION,
      imgUrl: savingcardImg,
    },
];

export default prefSelectOptions;
